enum Actions {
  // action types
  ADD_BODY_CLASSNAME = "addBodyClassName",
  REMOVE_BODY_CLASSNAME = "removeBodyClassName",
  ADD_BODY_ATTRIBUTE = "addBodyAttribute",
  REMOVE_BODY_ATTRIBUTE = "removeBodyAttribute",
  ADD_CLASSNAME = "addClassName",
  SET_BREADCRUMB_ACTION = "setBreadcrumbAction",
  SET_THEME_MODE_ACTION = "setThemeModeAction",

  //*** Axios Actions */
  AXIOS_INTERCEPTOR = "axiosInterceptor",
  DELETE_AXIOS_INTERCEPTOR = "deleteAxiosInterceptor",

  //*** Auth Module Actions */
  LOGIN = "login",
  LOGOUT = "logout",
  REGISTER = "register",
  VERIFY_CODE = "verify_code",
  UPDATE_USER = "updateUser",
  FORGOT_PASSWORD = "forgotPassword",
  REFRESH_TOKEN = "refreshToken",
  FORGOT_PASSWORD_SUBMIT = "forgotPasswordSubmit",
  CHANGE_PASSWORD = "changePassword",
  USER_ME = "userme",
  UPDATE_USER_ATTRIBUTES = "updateUserAttributes",

  /*** Admin Module Actions */
  TUTORIALS_LIST = "tutorialsList",
  TUTORIAL_RETRIEVE = "tutorialRetrieve",
  TUTORIAL_ITEM_RETRIEVE = "tutorialItemRetrieve",
  CREATE_TUTORIAL = "createTutorial",
  UPDATE_TUTORIAL = "updateTutorial",
  CREATE_TUTORIAL_ITEM = "createTutorialItem",
  DELETE_TUTORIAL = "deleteTutorial",
  DELETE_TUTORIAL_ITEM = "deleteTutorialItem",

  //*** Project Module Actions */
  GET_PROJECTS = "projectList",
  GET_PROJECT_RETRIEVE = "getProjectRetrieve",
  CREATE_PROJECT = "createProject",
  CHANGE_PROJECT = "changeProject",
  GET_DEVICES_OF_PROJECT = "getDevicesOfProject",
  GET_DEVICES_DATA_OF_PROJECT = "getDevicesDataOfProject",
  DELETE_DEVICE = "deleteDevice",
  GET_WS_CONNECTION_KIT = "getWsConnectionKit",
  GET_LIST_APIKEY_DEVICES = "getListApikeyDevices",

  //*** Report Module Actions */
  GET_REPORTS = "getReports",
  DOWNLOAD_REPORT = "downlloadReport",
  GENERATE_NEW_REPORT = "generateNewReport",

  //*** Settings Module Actions */
  RETRIEVES_TIMEZONE_LIST = "retrievesTimezoneList",
  RETRIEVES_LOCALE_LIST = "retrievesLocaleList",
  GET_USER_INFORMATION = "getUserInformation",
  GET_USER_AVAILABLE_PLANS = "getUserAvailablePlans",
  UPDATE_USER_BILLING_INFO = "updateUserBillingInfo",
  GET_COUNTRY_LIST = "getCountryList",
  GET_CITY_LIST = "getCityList",

  //*** subscriptions Module Actions */
  GET_SUBSCRIPTIONS_OF_PROJECT = "getSubscriptionsOfProject",
  GET_SUBSCRIPTION_CHECKOUT_FORM = "getSubscriptionCheckoutForm",
  GET_UPGRADE_CHECKOUT_FORM = "getUpgradeCheckoutForm",
  GET_CHANGE_PAYMENT_CHECKOUT_FORM = "getChangePaymentCheckoutForm",
  CANCEL_PROJECT_SUBSCRIPTION = "cancelProjectSubscription",

  //*** Contract Actions */
  GET_CONTRACT = "getContract",

  //** API Error Messages Module Actions */
  API_ERROR_MESSAGE = "apiErrorMessage",
}

enum Mutations {
  // mutation types
  SET_CLASSNAME_BY_POSITION = "appendBreadcrumb",
  SET_BREADCRUMB_MUTATION = "setBreadcrumbMutation",
  SET_LAYOUT_CONFIG_PROPERTY = "setLayoutConfigProperty",
  RESET_LAYOUT_CONFIG = "resetLayoutConfig",
  OVERRIDE_LAYOUT_CONFIG = "overrideLayoutConfig",
  OVERRIDE_PAGE_LAYOUT_CONFIG = "overridePageLayoutConfig",
  SET_THEME_MODE_MUTATION = "setThemeModeMutation",

  //*** Axios Mutations */
  SET_ITERCEPTOR = "setInterceptor",
  ITERCEPTOR_REFRESH_COUNT = "interceptorRefreshCount",
  ITERCEPTOR_INCREMENT_REFRESH_COUNT = "interceptorIncrementRefreshCount",
  ITERCEPTOR_CLEAR_REFRESH_COUNT = "interceptorClearRefreshCount",

  //*** Auth Module Mutations */
  SET_TOKEN = "setToken",
  SET_PERMISSIONS = "setPermissions",
  SET_AUTH_ERROR = "setAuthError",
  PURGE_AUTH = "logOut",
  SET_USER = "setUser",
  SET_ERROR = "setError",

  //*** Project Module Mutations */
  SET_PROJECT = "setProject",
  SET_NEW_PROJECT = "setNewProject",
  LOAD_PROJECTS = "loadProjects",
  SET_DEVICES_OF_PROJECT = "setDevicesOfProject",

  //*** Report Module Mutations */
  SET_REPORT = "setReport",

  //** API Error Messages Module Mutations */
  SET_API_ERROR_MESSAGE = "setAPIErrorMessage",
}

export { Actions, Mutations };
